import * as types from './mutation-types'
import zonesService from '../../services/zones'
import { createServiceCall } from '../actionsUtil'

export const getZones = createServiceCall({
  mainAction: types.GET_ZONES_REQUEST,
  serviceFunction: zonesService.getZones,
  successAction: types.GET_ZONES_SUCCESS,
  successDataPropery: 'listZones',
  failureAction: types.GET_ZONES_FAILURE
})
